import React, { FC } from 'react';
import { CustomTabsPanelComponentProps } from './CustomTabsPanelComponentProps';
import { Stack } from '@mui/material';
import CustomTabPanel from '../../common/CustomTabPanel';
const CustomTabsPanelComponent: FC<CustomTabsPanelComponentProps> = ({
  activeTab,
  panelsList,
}) => {
  return (
    <Stack p={3}>
      {panelsList.map((panel) => (
        <CustomTabPanel
          key={panel.value}
          index={activeTab}
          value={panel.value}
          dataTestID={panel.dataTestID}
        >
          {panel.component}
        </CustomTabPanel>
      ))}
    </Stack>
  );
};

export default CustomTabsPanelComponent;
